<div class="flex flex-col">
  <span class="flex self-end material-icons cursor-pointer" (click)="downloadCurrentImage()">download</span>
  <div class="flex flex-row items-center">
    <div class="flex-1">
      <pinch-zoom>
        <img [src]="data.data" alt="Image preview" style="height: 600px !important" />
      </pinch-zoom>
    </div>
  </div>
</div>
